export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./~/@swimlane/ngx-charts/~/d3-format/src/identity.js
// module id = 686
// module chunks = 0